import script from "./svgIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./svgIcon.vue?vue&type=script&setup=true&lang=ts"

import "./svgIcon.vue?vue&type=style&index=0&id=25a02a3b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25a02a3b"]])

export default __exports__